module.exports = __webpack_public_path__ + "fonts/ralewaymediumitalic.0061a71.woff";